/**
 * Sezioni delle Impostazioni. «Consumer» (#13) è il registro delle installazioni; «Prodotti» (#18)
 * governa prefissi, categorie per canale e regole lette dai consumer (DEC-003). «Coda ed email»
 * (#10) vale oggi per l'unica istanza.
 */
export const SETTINGS_SECTIONS = [
  { path: '/impostazioni/team', label: 'Team' },
  { path: '/impostazioni/coda', label: 'Coda ed email' },
  { path: '/impostazioni/consumer', label: 'Consumer' },
  { path: '/impostazioni/prodotti', label: 'Prodotti' },
] as const;
